import { render } from "./App.vue?vue&type=template&id=776427ea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=776427ea&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__